import { KEYS, sessionCache } from '@services/cache';

const { TRACKING_DATA } = KEYS;

function getTrackingData() {
  return sessionCache.get(TRACKING_DATA) || [];
}

export default getTrackingData;
